<template>
  <div>
    <template v-if="config.global.homeSliderFull">
      <Slider maxHeight="100vh" />
    </template>
    <template v-if="!config.global.homeSliderFull">
      <Slider />
    </template>
    <template v-if="body">
      <div class="wrap">
        <div class="page-content" v-html="body" />
      </div>
    </template>
    <div class="wrap">
      <Level4Search />
      <Locations />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Level4Search from '@/modules/level4/components/Level4Search.vue';
import { Slider, config } from '@/modules/core';
import appConfig from '@/config';
import Locations from '../components/Locations.vue';

const { endpoints } = appConfig.page;

export default {
  name: 'Home',
  mixins: [config],
  components: {
    Slider,
    Level4Search,
    Locations,
  },
  data() {
    return {
      body: '',
    };
  },
  created() {
    axios({ url: endpoints.page('homepage') })
      .then(({ data }) => {
        this.body = data.Body;
      });
  },

};
</script>
